/**
@ngdoc controller
@name submitCandToItemCtrl

@description
This controller is used in Candididate Submission from Candidate or Item.

*/
(function() {
    'use strict';
     var submitCandToItemCtrl = function($scope, ajaxCall, $timeout, xmsNotificationFactory,$window) {
        console.log("Inside submitCandToItemCtrl");
        $scope.submitCandToItemModel = {candidateList: [], totalCandidateCount: 0, watchCount: 0};
        $scope.candidateSearchModel = {};
        $scope.markasSubmittedFlag= {};
        $scope.loading      = true;
        $scope.submitted    = false;
        $scope.loadingError = false;
        $scope.candidateSearchModel.myOUOnly = true;

        $scope.candidateSearchModel.candidatesCollapse = true;
        $scope.candidateSearched=false;

        $scope.markasSubmittedFlag = $scope.submitCandToItemModel.markAsSubmitted;
        // added watch event to delay the ckEditor load, in order to avoid destory() on ckEditor
        // before it is fully initialized
        $scope.submitCandToItemModel.delayedEditorLoad = true;
        $scope.$watch(
            function(){
                 return $scope.submitCandToItemModel.candidateId;
            },
            function(newVal, oldVal){
                if(newVal!=oldVal){

                    $scope.submitCandToItemModel.delayedEditorLoad = false;
                    $timeout(function(){
                        $scope.submitCandToItemModel.delayedEditorLoad = true;
                    });
                }
            }
        );

         $scope.fnCvWatcher = function(){
             for(var key in $scope.submitCandToItemModel.candidateList) {
                 if (key >= $scope.submitCandToItemModel.watchCount) {
                     $scope.$watch("submitCandToItemModel.candidateList['" + key + "'].candidateCvList.defaultCV", function (val, oldVal) {

                         if (val != oldVal) {
                             $scope.fnAttachmentSize();
                         }
                     });
                 }
                 $scope.submitCandToItemModel.watchCount = $scope.submitCandToItemModel.totalCandidateCount;
             }
         };

        // duplicated from app.js as modal window doesn't have the access to the main scope
        $scope.ckLoad = {
            ckeditor: {
                name:'ngCkeditor', files:[
                WEBAPP_PATH + '/js/vendor/angular/ng-ckeditor/ng-ckeditor.js',
                WEBAPP_PATH + '/js/vendor/CKEditor/ckeditor.js'
            ]}
        };


        var ajaxCallList = function(ajaxUrl, data) {

            ajaxCall.getData(ajaxUrl, data).then(
                 function(response){
                    if (response.data.isLink) {
                        $window.location.href=response.data.link;
                    }
                    else if (response.data.error){
                        $scope.ok();
                        xmsNotificationFactory.addObj({id: "submitCandidatePop", type: "danger", bodyHtml: response.data.msg, timeout:10});
                    }
                    else{
                        $scope.ok();
                        xmsNotificationFactory.addObj({id: "submitCandidatePop", type: "success", bodyHtml: response.data.msg, timeout:10});
                    }
                },
                function(response) {
                    $scope.ok();
                    xmsNotificationFactory.addObj({id: "submitCandidatePop", type: "danger", bodyHtml: response.data.msg, timeout:10});
                }
            );
        };

        $scope.fnCandidateCount = function(){
            var candidateCount = 0;
            angular.forEach($scope.submitCandToItemModel.candidateList, function(candidate){
                if (!angular.isDefined(candidate.active) || candidate.active){
                    candidateCount++;
                }
            });
            $scope.submitCandToItemModel.totalCandidateCount = candidateCount;
        };

        $scope.fnResetSearch = function(){
            $scope.candidates = null;
            $scope.candidateSearched = false;
            $scope.submitCandToItemModel = {candidateList: [], totalCandidateCount: 0, watchCount: 0};
        };

        $scope.fnSearchCandidates = function(itemId) {
            $scope.loadingCandidates = true;
            $scope.candidates = [];
            $scope.submitCandToItemModel.candidateId = null;
            $scope.candidateSearchModel.candidatesCollapse = false;
            $scope.candidateSearched=true;
            var url = WEBAPP_PATH + '/candidate/candidateSearch?itemId='+itemId+'&term='+$scope.candidateSearchModel.candidateName+'&myOUOnly='+$scope.candidateSearchModel.myOUOnly
            +'&prospectiveSubmission='+$scope.candidateSearchModel.prospectiveSubmission

            ajaxCall.getData(url).then(
                function(response){
                    var objectArr = [];
                    angular.forEach(response.data, function(resp){
                        var obj = {};
                        angular.forEach(resp, function(value, key){
                            this[key] = value;
                        }, obj);
                        objectArr.push(obj);
                    });
                    $scope.candidates = objectArr;
                    $scope.loadingCandidates = false;
                },
                function(response) {
                    $scope.ok();
                    xmsNotificationFactory.addObj({id: "submitCandidatePop", type: "danger", bodyHtml: response.data, timeout:10});
                }
            );
        };

        $scope.fnAttachmentSize = function(){
            var attachmentSize = 0;
            angular.forEach($scope.submitCandToItemModel.candidateList, function(candidate){
                if (candidate.active && candidate.candidateCvList.defaultCV){
                    angular.forEach(candidate.candidateCvList.cvAttachmentInstanceList, function(attachment){
                        if (attachment.id == candidate.candidateCvList.defaultCV){
                            attachmentSize += attachment.attachmentSize;
                        }
                    });
                }
            });
            $scope.submitCandToItemModel.totalAttachmentSize = attachmentSize;
            if (attachmentSize > 10000000) {
                $scope.submitCandToItemModel.emailViaXms = false;
            }
        };

        $scope.fnCheckProspectiveSubmission = function(){
                $scope.submitCandToItemModel.emailViaXms = false;
        };

        /**
        * TODO: Refactor for X3-16523: Could be upgraded to include isId
        */
        var useDefinedOrFailover = function (modelRef, failoverValue) {
            return angular.isDefined(modelRef) ? modelRef : failoverValue;
        };

        var isPrincipal = function () {
            return useDefinedOrFailover($scope.submitCandToItemModel.isPrincipal, true);
        };

        $scope.fnSubmitCandidate = function(submitDirect){
            $scope.submitted=true;
            var urlPost = WEBAPP_PATH + "/candidateSubmission/" + (isPrincipal() ? "submitCandidate" : "submitCandidateCorporate") + "?";
            // TODO: Refactor for X3-16523: Check logic if(!null) set null - Why not just set it to null?
            for(var candCount = 0; candCount<$scope.submitCandToItemModel.candidateList.length;candCount++){
                if( (typeof $scope.submitCandToItemModel.candidateList[candCount].candidateCvList !== 'undefined')
                    && $scope.submitCandToItemModel.candidateList[candCount].candidateCvList.cvList != null){
                    $scope.submitCandToItemModel.candidateList[candCount].candidateCvList.cvList = null;
                }
            }
            var data = {
                distributionLookup    : $scope.submitCandToItemModel.distributionLookup.key,
                // TODO: Refactor for X3-16523: Unify identical block below and remove repetition.
                managerId           : angular.isDefined($scope.submitCandToItemModel.manager)           ? $scope.submitCandToItemModel.manager.id        : '',
                emailViaXms         : angular.isDefined($scope.submitCandToItemModel.emailViaXms)       ? $scope.submitCandToItemModel.emailViaXms       : '',
                subject             : angular.isDefined($scope.submitCandToItemModel.subject)           ? $scope.submitCandToItemModel.subject           : '',
                messageBody         : angular.isDefined($scope.submitCandToItemModel.messageBody)       ? $scope.submitCandToItemModel.messageBody       : '',
                sendCopy            : angular.isDefined($scope.submitCandToItemModel.sendCopy)          ? $scope.submitCandToItemModel.sendCopy          : '',
                prospectiveSubmission            : angular.isDefined($scope.submitCandToItemModel.prospectiveSubmission)          ? $scope.submitCandToItemModel.prospectiveSubmission          : '',
                candidateList         : angular.isDefined($scope.submitCandToItemModel.candidateList)       ? $scope.submitCandToItemModel.candidateList       : '',
                submitDirect    : submitDirect,
                candidateAnonymisationType            : angular.isDefined($scope.submitCandToItemModel.candidateAnonymisationType)          ? $scope.submitCandToItemModel.candidateAnonymisationType.id          : '',
                commType            : angular.isDefined($scope.submitCandToItemModel.commType)          ? $scope.submitCandToItemModel.commType          : ''

            };
            ajaxCallList(urlPost , data);
        };

        $scope.fnSubmitCandidateFromItem = function(){
            var urlPost= WEBAPP_PATH + "/candidateSubmission/saveSubmissionFromItem?";
            // TODO: Refactor for X3-16523: Check logic if(!null) set null - Why not just set it to null?
            for(var candCount = 0; candCount<$scope.submitCandToItemModel.candidateList.length;candCount++){
                if($scope.submitCandToItemModel.candidateList[candCount].candidateCvList.cvList != null){
                    $scope.submitCandToItemModel.candidateList[candCount].candidateCvList.cvList = null;
                }
            }

            var data = {
                // TODO: Refactor for X3-16523: Unify identical block below and remove repetition.
                managerId           : angular.isDefined($scope.submitCandToItemModel.manager)           ? $scope.submitCandToItemModel.manager.id       : '',
                emailViaXms         : angular.isDefined($scope.submitCandToItemModel.emailViaXms)       ? $scope.submitCandToItemModel.emailViaXms      : '',
                subject             : angular.isDefined($scope.submitCandToItemModel.subject)           ? $scope.submitCandToItemModel.subject          : '',
                messageBody         : angular.isDefined($scope.submitCandToItemModel.messageBody)       ? $scope.submitCandToItemModel.messageBody      : '',
                sendCopy            : angular.isDefined($scope.submitCandToItemModel.sendCopy)          ? $scope.submitCandToItemModel.sendCopy         : '',
                candidateList         : angular.isDefined($scope.submitCandToItemModel.candidateList)       ? $scope.submitCandToItemModel.candidateList      : '',
                itemId              : angular.isDefined($scope.candidateSearchModel.itemId)             ? $scope.candidateSearchModel.itemId            : '',
                markAsSubmitted        : angular.isDefined($scope.submitCandToItemModel.markAsSubmitted)      ? $scope.submitCandToItemModel.markAsSubmitted     : '',
                prospectiveSubmission            : angular.isDefined($scope.submitCandToItemModel.prospectiveSubmission)          ? $scope.submitCandToItemModel.prospectiveSubmission          : '',
                candidateAnonymisationType            : angular.isDefined($scope.submitCandToItemModel.candidateAnonymisationType)          ? $scope.submitCandToItemModel.candidateAnonymisationType.id          : '',
                commType            : angular.isDefined($scope.submitCandToItemModel.commType)          ? $scope.submitCandToItemModel.commType          : ''

            };
            ajaxCallList(urlPost , data);
        };

         $scope.fnBuildEmail= function (){
            var template = $scope.submitCandToItemModel.emailTemplates[$scope.submitCandToItemModel.selectedTemplate];
            var email = $("<div>" +$scope.submitCandToItemModel.defaultMessageBody+ "</div>");
             var $salutation = email.find("#salutation");
             if($scope.submitCandToItemModel.removeSalutation === 'Y'){
                 email.find("#wholeSalutation").replaceWith('');
             }else{
                 if($scope.submitCandToItemModel.selectedSalutation === undefined){
                     email.find("#wholeSalutation").replaceWith(addSalutation(false));
                 }else{
                     email.find("#salutation").replaceWith(addSalutation(true));
                 }
             }
             $scope.submitCandToItemModel.commType  = template.TEMPCOMMTYPE;
             $scope.submitCandToItemModel.removeSalutation = template.REMOVE_SALUTATION;
             $scope.submitCandToItemModel.subject = template.SUBJECTLINE;

             email.find("#messageBody").html(template.emailContent);

             if(email.find("#signature").length == 0) {
                 email.append('<div id="signature"></div>');
             }

             $scope.submitCandToItemModel.messageBody = email.html();
         };

         $scope.fnUpdateForm = function (){
             var template = $scope.submitCandToItemModel.selectedTemplate;
             $scope.submitCandToItemModel.template = template.emailContent;
             $scope.submitCandToItemModel.commType  = template.TEMPCOMMTYPE;
             $scope.submitCandToItemModel.removeSalutation = template.REMOVE_SALUTATION;
         };

         $scope.fnRemoveCandidate = function () {
             $scope.submitCandToItemModel.candidateId = -1;
             if($scope.submitCandToItemModel.totalCandidateCount === 0){
                 $scope.candidateSearchModel.candidatesCollapse = false;
             }
         };

         var addSalutation = function (hasSalutation){
            if(!hasSalutation){
                return '<div id="wholeSalutation">Dear&nbsp;<span id="salutation">[Addressee]</span></div>';
            }else{
                if($scope.submitCandToItemModel.selectedSalutation.length == 0 ){
                    return '<span id="salutation">[Addressee]</span>';
                }else{
                    return '<span id="salutation">'+$scope.submitCandToItemModel.selectedSalutation+'</span>';
                }
            }
         };

       $scope.fnCheckEligibilityToSubmit = function(itemId) {
         var data = {
           candidateIds    : angular.isDefined($scope.submitCandToItemModel.candList)            ? $scope.submitCandToItemModel.candList                : '',
           distributionId  : angular.isDefined($scope.submitCandToItemModel.distributionLookup)  ? $scope.submitCandToItemModel.distributionLookup.key  : ''
         };
         var url = WEBAPP_PATH + '/candidateSubmission/checkEligibilityToSubmit?';

         ajaxCall.getData(url, data).then(
           function(response){
             $scope.isDobAndAddressEligible = response.data === "true";
           }
         );
       };
    };
    submitCandToItemCtrl.$inject = ['$scope', 'ajaxCall', '$timeout', 'xmsNotificationFactory','$window'];
    angular.module('app').controller('submitCandToItemCtrl', submitCandToItemCtrl);
}());
